<template>
    <div class="w-100">
        <template v-if="append !== '' || prepend !== '' || format !== ''">
            <b-input-group :prepend="prepend" :append="append">
                <template v-if="format === 'percentage'">
                    <input v-model.lazy="localPercentageValue" :type="type" class="form-control" :readonly="readonly" :placeholder="placeholder" v-mask="mask">
                </template>
                <template v-else-if="format === 'number'">
                    <input type="text" v-model.lazy="displayNumber" class="form-control" :readonly="readonly" :placeholder="placeholder" v-mask="mask" v-debounce:1000ms="debFuncNumber"/>
                </template>
                <template v-else-if="format === 'decimal'">
                    <input type="text" v-model.lazy="displayDecimal" class="form-control" :readonly="readonly" :placeholder="placeholder" v-mask="mask" v-debounce:1000ms="debFunc"/>
                </template>
                <template v-else>
                    <input v-model.lazy="localValue" :type="type" class="form-control" :readonly="readonly" :placeholder="placeholder" v-mask="mask">
                </template>
            </b-input-group>
            <template v-if="showInfo && description">
              <fa icon="fa-info-circle" class="float-left pt-1 pr-2" :id="tooltipID"></fa>
              <b-tooltip :target="tooltipID" triggers="hover">
                {{ showInfoDescirption }}
              </b-tooltip>
            </template>
            <small v-if="description" tabindex="-1" class="form-text float-left" :class="descriptionClass">{{ description }}</small>
            <small v-if="rightdescription" tabindex="-1" class="form-text float-right" :class="rightdescriptionClass">{{ rightdescription }}</small>
        </template>
        <template v-else>
            <input v-model.lazy="localValue" :type="type" class="form-control" :readonly="readonly" :placeholder="placeholder" v-mask="mask">
        </template>
    </div>
</template>

<script>
  export default {
    name: 'o-input-mask-control',
    props: {
      value: {
        default: null
      },
      type: {
        type: String,
        default: 'text'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String
      },
      mask: {
        type: String
      },
      append: {
        type: String,
        default: ''
      },
      prepend: {
        type: String,
        default: ''
      },
      format: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      descriptionClass: {
        default: 'text-muted'
      },
      rightdescription: {
        type: String,
        default: ''
      },
      rightdescriptionClass: {
        default: 'text-muted'
      },
      showInfo: {
        type: Boolean,
        default: false
      },
      showInfoDescirption: {
        type: String,
        default: ''
      }
    },

    data: () => ({
      localValue: '',
      tooltipID: Math.random().toString(36).substring(2,7)
    }),

    mounted() {
      this.localValue = this.value
      if(this.isPercentage) {

      }
    },

    components: {},

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },
    methods: {
      debFunc (val, e) {
        if(val) {
          let newNumber = parseFloat(val.replace(/[^\d\.]/g, ""))
          let number = parseFloat(newNumber).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1’")
          if (number === 'NaN') {
            number = null
          }
          this.displayNumber = number
        }
      },
      debFuncNumber (val, e) {
        if(val) {
          let newNumber = parseFloat(val.replace(/[^\d\.]/g, ""))
          var ret = new Intl.NumberFormat('de-CH', {minimumFractionDigits: 0}).format(Math.round(newNumber))
          ret = ret.replace("\u2019", "'")
          if (ret === 'NaN') {
            ret = null
          }
          this.displayNumber = ret
        }
      }
    },
    computed: {
      localPercentageValue: {
        get: function () {
          return parseFloat(this.localValue * 100).toFixed(2)
        },
        set: function (newValue) {
          this.localValue = newValue / 100
        }
      },
      displayNumber: {
        get: function() {
          var ret = new Intl.NumberFormat('de-CH', {minimumFractionDigits: 0}).format(Math.round(this.localValue))
          ret = ret.replace("\u2019", "'")
          if (ret === 'NaN') {
            ret = null
          }
          return ret
        },
        set: function(number) {
          let newNumber = parseInt(number.replace(/[^\d\.]/g, ""))
          if (isNaN(newNumber)) {
            newNumber = null
          }
          this.$emit('input', newNumber)
        }
      },
      displayDecimal: {
        get: function() {
          let number = parseFloat(this.localValue).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1’")
          if (number === 'NaN') {
            number = null
          }
          return number
        },
        set: function(number) {
          let newNumber = parseFloat(number.replace(/[^\d\.]/g, ""))
          if (isNaN(newNumber)) {
            newNumber = null
          }
          this.$emit('input', newNumber)
        }
      }
    }
  }
</script>
